import React, { useContext, useEffect, useState } from 'react'
import { Await, NavLink } from 'react-router-dom'
import { ImExit } from 'react-icons/im'
import LoginContext from '../../Context/Logincontext'
import Swal from 'sweetalert2'
import { AiTwotoneDelete, AiFillEdit } from 'react-icons/ai';
import { urlApiServer } from '../../Config/Config'

const AddProductGeneric = (props) => {
    // let edit = props.edit
    let saveProduct = props.saveProduct
    let historyValidation = props.historyValidation
    let saveItemPrice = props.saveItemPrice
    let oldData = props.oldData;
    let oldIva = props.oldIva
    let toggleFullScreen = props.toggleFullScreen
    let ivaProdut = 0

    const [productOptions, setProductOptions] = useState(null)
    const { infoUser, setInfoUser } = useContext(LoginContext)
    const [deletoglee, setDeletogle] = useState(false)
    const [compositeProduct, setCompositeProduct] = useState([])
    const [productName, setProductName] = useState('')
    const [productQuantity, setProductQuantity] = useState()
    const [productIva, setProductIva] = useState()
    const [unit, setUnit] = useState()
    const [clientGetTable, setClientGetTable] = useState([])
    const [utility, setUtility] = useState('');
    const [rawMaterialGetTable, setRawMaterialGetTable] = useState([]);
    const [selectedMaterials, setSelectedMaterials] = useState([]);
    const [currentMaterial, setCurrentMaterial] = useState({
        material: null,
        quantity: '',
        extent: '',
        pricePerMeasure: ''
    });
    const [productPrice, setProductPrice] = useState()
    // const [total, setTotal] = useState(0)
    const [reload, setReload] = useState(false)


    const [isFullScreen, setFullScreen] = useState(false);
    const [id, setId] = useState()

    const urlgetProducts = urlApiServer + "products"
    const urlgetCompositeproduct = urlApiServer + "getCompositeproduct"
    const urlGetRawMaterial = urlApiServer + "rawMaterial";

    useEffect(() => {
        // Función para cargar materiales
        const loadRawMaterials = async () => {
            try {
                const InicioHeaders = new Headers();
                InicioHeaders.append("Content-Type", "application/json");
                InicioHeaders.append("company", infoUser.company);

                const response = await fetch(urlGetRawMaterial, {
                    method: 'GET',
                    headers: InicioHeaders
                });

                const data = await response.json();
                setRawMaterialGetTable(data.reverse());
            } catch (error) {
                console.error("Error loading raw materials:", error);
            }
        };

        loadRawMaterials();
    }, [infoUser.company]);


    useEffect(() => {
    }, [reload, deletoglee])

    useEffect(() => {
        (async function () {

            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json");
            InicioHeaders.append("company", infoUser.company);

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            }
            await fetch(urlgetProducts, requesoption)
                .then(response => response.json())
                .then(quotesResponse => {
                    setClientGetTable(quotesResponse);
                })
                .catch(error => {
                });
        }())

    }, [])

    useEffect(() => {
        (async function () {
            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json");
            InicioHeaders.append("company", infoUser.company); // Enviar el nombre de la empresa como encabezado

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            };

            await fetch(urlgetCompositeproduct, requesoption)
                .then(response => response.json())
                .then(quotesResponse => {
                    setCompositeProduct(quotesResponse.reverse());
                })
                .catch(error => {
                });

            const InicioHeaders2 = new Headers();
            InicioHeaders2.append("Content-Type", "application/json");
            InicioHeaders2.append("company", infoUser.company); // Enviar el nombre de la empresa como encabezado

            const requesoption2 = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            };

        }())

    }, [urlgetCompositeproduct])

    useEffect(() => {
        if (productOptions === 'product' || productOptions === null) {
            clientGetTable.forEach((info) => {
                if (productName === info.producto) {
                    setProductPrice(info.precioitem);
                    setProductQuantity(parseFloat(info.cantidaditem));
                    setUnit(info.unit);
                    setProductIva(info.iva);
                }
            });
        } else if (productOptions === 'compositeProduct') {
            compositeProduct.forEach((info) => {
                console.log('info compositeProduct: ', info)
                if (productName === info.product) {
                    setProductPrice(info.laborprice);
                    setUnit(info.unit);
                    setProductIva(info.vat);
                    setUtility(info.utility)
                }
            });
        }
    }, [productName]);

    const handleCompositeProductSelection = (materialsWithId) => {

        console.log('Materials: ', materialsWithId)

        if (props.MaterialInventaryCompositeProduct) {
            props.MaterialInventaryCompositeProduct(materialsWithId); // Ya incluye el productId
        }
    }

    const handleAddMaterial = () => {
        if (currentMaterial.material) {
            setSelectedMaterials([...selectedMaterials, currentMaterial]);
            setCurrentMaterial({
                material: null,
                extent: '',
                pricePerMeasure: ''
            });
        }
    };

    const handleRemoveMaterial = (index) => {
        const updatedMaterials = [...selectedMaterials];
        updatedMaterials.splice(index, 1);
        setSelectedMaterials(updatedMaterials);
    };

    const handleMaterialChange = (e) => {
        const materialName = e.target.value;
        const material = rawMaterialGetTable.find(m => m.nameofmaterial === materialName);

        setCurrentMaterial({
            ...currentMaterial,
            material: material || null,
            pricePerMeasure: material ? material.pricePerMeasure : '',
            extent: material?.typeOfMeasure === "cantidad" ? '' : currentMaterial.extent
        });
    };

    const handleMaterialExtentChange = (e) => {
        setCurrentMaterial({
            ...currentMaterial,
            extent: e.target.value.replace(/[^0-9-._]/g, '')
        });
    };

    const resetForm = () => {
        setProductName('');
        setProductPrice('');
        setProductQuantity('');
        setProductIva('');
        setUnit('');
        setUtility('');
        setSelectedMaterials([]);
        setCurrentMaterial({
            material: null,
            extent: '',
            pricePerMeasure: ''
        });
        setProductOptions(null);
    };


    function addProduct() {

        if (!productQuantity || isNaN(productQuantity) || parseFloat(productQuantity) <= 0) {
            return Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Debe ingresar una cantidad válida mayor a cero',
            });
        }

        const productId = Date.now(); // Genera un ID único (o usa UUID/v4 si prefieres)

        const priceAndQuantity = productPrice * productQuantity
        let ivaProduct = priceAndQuantity * (parseFloat(productIva) / 100)
        const totalAndIva = priceAndQuantity + ivaProduct

        let data = {
            id: props.edit === 'Edit' ? props.historyValidation.Id : undefined,
            empresa: infoUser.companyType,
            producto: productName,
            precioitem: priceAndQuantity,
            cantidadItem: productQuantity,
            total: totalAndIva,
            Priceiva: totalAndIva,
            iva: productIva,
            price: productPrice,
            unit: unit,
            productId: productId,
            utility: utility
        };

        console.log('products: ', data)

        saveProduct.push(data)
        const totalPrice = saveProduct.reduce((acc, item) => acc + item.total, 0);
        props.priceEndFunction(totalPrice)

        if (productOptions === 'product' && selectedMaterials.length > 0) {
            const materialsWithSameId = selectedMaterials.map(material => ({
                ...material,
                productId: productId,
                parentProductName: productName
            }));
            data.materials = materialsWithSameId;

            if (props.MaterialInventaryCompositeProduct) {
                props.MaterialInventaryCompositeProduct(materialsWithSameId, productName);
            }
        }

        if (productOptions === 'compositeProduct') {
            const selectedComposite = compositeProduct.find(item => item.product === productName);
            if (selectedComposite?.materials) {
                const materialsWithSameId = selectedComposite.materials.map(material => ({
                    ...material,
                    productId: productId, // Mismo ID que el producto padre
                    parentProductName: productName, // Opcional: para referencia rápida
                }));
                handleCompositeProductSelection(materialsWithSameId, productName);
            }
        }

        if (reload) {
            setReload(false)
        } else {
            setReload(true)
        }

        props.calculate()

    }


    function handleProductName(e) {
        const name = e.target.value
        if (name.length < 3001) {
            setProductName(name)
        } else {
            return Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'El maximo de caracteres para el detalle es de 3000',
            })
        }
    }

    function handleProductPrice(e) {
        const price = e.target.value
        if (price.length < 100) {
            setProductPrice(price)
        } else {
            return Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'El maximo de caracteres para el precio es de 100',
            })
        }
    }

    function handleProductIva(e) {
        const iva = e.target.value
        setProductIva(iva)
        // console.log("iva: ", e.target.value)
    }

    function handleUnit(e) {
        const unit = e.target.value
        setUnit(unit)
        // console.log("iva: ", e.target.value)
    }

    function handleProductQuantity(e) {
        const quantity = e.target.value
        setProductQuantity(quantity)
        // console.log("quantity: ", e.target.value)
    }

    async function handleUtility(e) {
        const utility = e.target.value.replace(/[^0-9.]/g, '');
        setUtility(utility);
    }

    async function optionProduct() {
        setProductOptions('product')
    }

    async function optionCompositeProduct() {
        setProductOptions('compositeProduct')
    }

    async function back() {
        setProductOptions(null)
    }

    return (
        <form className='ContainerAddCuotes'>
            <div className='containerQuotes'>
                <div className='infoOneQuotes'>
                    <p className='texProducttitule'>PRODUCTOS</p>
                    <div className="containerTable">
                        <table id='test-table' className="minimal-table">
                            <tr>
                                <th>Productos</th>
                                <th>Precio Unidad</th>
                                <th>Cantidad</th>
                                <th>Total</th>
                                <th>Iva</th>
                                {/* <th>Utilidad</th> */}
                                <th>Total + iva</th>
                                <th>Eliminar</th>
                                <th>Editar</th>
                            </tr>
                            {saveProduct.map((product, index) => {
                                async function deleteProduct1(index) {
                                    const productToDelete = saveProduct[index];
                                    Swal.fire({
                                        icon: 'question',
                                        text: '¿Estás seguro que deseas eliminar este item y sus materiales asociados?',
                                        showCancelButton: true,
                                        confirmButtonText: 'Aceptar',
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            // Eliminar materiales asociados primero
                                            if (props.removeMaterialsByProductId && productToDelete.productId) {
                                                props.removeMaterialsByProductId(productToDelete.productId);
                                            }

                                            // Luego eliminar el producto
                                            setDeletogle(true);
                                            saveItemPrice = [];
                                            delete saveProduct[index];
                                            saveProduct = saveProduct.filter(function (el) {
                                                return el != null;
                                            });
                                            props.Reload(saveProduct);
                                        }
                                    });
                                }
                                async function Edit(index) {
                                    oldData = saveProduct[index].Priceiva
                                    oldIva = saveProduct[index].iva
                                    setId(index)
                                    setFullScreen(true)

                                    await Swal.fire({
                                        title: 'Editar',
                                        html:
                                            `
                                        <div>
                                            <p>Producto:</p>
                                            <input type="text" id="producto" value="${saveProduct[index].producto}" class="swal2-input" placeholder="Producto">
                                        </div>
                                        <div>
                                            <p>Precio del producto:</p>
                                            <input type="text" id="precioitem" value="${saveProduct[index].price}" class="swal2-input" placeholder="Precio del producto">
                                        </div>
                                        <div>
                                        <p>Cantidad:</p>
                                            <input type="text" id="cantidadItem" value="${saveProduct[index].cantidadItem}" class="swal2-input" placeholder="Cantidad">
                                        </div>
                                        <div>
                                        <div>
                                            <p>Unidades:</p>
                                            <select id="mySelectUnit" class="ivaSelect">
                                            <option value="${saveProduct[index].unit}" >Unidad: ${saveProduct[index].unit}</option>
                                            <option value="U">U (Unidad)</option>
                                            <option value="M">M (Metros)</option>
                                            <option value="M2">M2 (Metros Cuadrados)</option>
                                            <option value="C">C (Centimetros)</option>
                                            <option value="P">P (Pulgadas)</option>
                                            <option value="K">K (Kilogramos)</option>
                                            <option value="G">G (Gramos)</option>
                                            <option value="L">L (Libras)</option>
                                            <option value="LT">LT (Litros)</option>
                                            <option value="R">R (Radianes)</option>
                                            <option value="R">S (Segundos)</option>
                                            <option value="H">H (Horas)</option>
                                            <option value="Dia/s">Dias</option>
                                            <option value="Mes/es">Meses</option>
                                            <option value="Año/s">Años</option>
                                            </select>
                                        </div>
                                
                                            <p>Iva:</p>
                                            <select id="mySelect" class="ivaSelect">
                                                <option value="${saveProduct[index].iva}" >Iva: ${saveProduct[index].iva}</option>
                                                <option value="0">0%</option>
                                                <option value="5">5%</option>
                                                <option value="16">16%</option>
                                                <option value="19">19%</option>
                                            </select>
                                        </div>
                                        </div>
                                        `,
                                        showCancelButton: true,
                                        focusConfirm: false,
                                        preConfirm: () => {
                                            return [
                                                document.getElementById('producto').value,
                                                document.getElementById('cantidadItem').value,
                                                document.getElementById('precioitem').value,
                                                document.getElementById('mySelectUnit').value,
                                                document.getElementById('mySelect').value,
                                                // document.getElementById('utility').value
                                            ]
                                        }
                                    }).then(response => {
                                        if (response.value) {
                                            const priceAndQuantity = parseFloat(response.value[2]) * parseFloat(response.value[1]);
                                            let ivaProduct = priceAndQuantity * (parseFloat(response.value[4]) / 100);
                                            const total = priceAndQuantity + ivaProduct;

                                            if (response.value[0].length > 3001) {
                                                return Swal.fire({
                                                    icon: 'error',
                                                    title: 'Error',
                                                    text: 'El maximo de caracteres para el detalle es de 3001',
                                                });
                                            }

                                            if (response.value[2].length > 100) {
                                                return Swal.fire({
                                                    icon: 'error',
                                                    title: 'Error',
                                                    text: 'El maximo de caracteres para el precio es de 500',
                                                });
                                            }

                                            let obj = {
                                                "producto": response.value[0],
                                                "Id": null,
                                                'cantidadItem': response.value[1],
                                                "price": response.value[2],
                                                "precioitem": priceAndQuantity,
                                                "iva": response.value[4].toString(),
                                                // 'utility': response.value[5].toString(), // Asegúrate de incluir la utilidad aquí
                                                'total': total,
                                                'unit': response.value[3],
                                            };

                                            let updateArraySaveProduct = saveProduct.slice();
                                            updateArraySaveProduct[index] = obj;
                                            saveProduct = updateArraySaveProduct;
                                            props.Reload(saveProduct);
                                        }
                                    });
                                }
                                return (
                                    <tr>
                                        <td>{product.producto}</td>
                                        <td>${Math.round(product.price)}</td>
                                        <td>{product.cantidadItem}</td>
                                        <td>${Math.round(product.precioitem)}</td>
                                        <td>{product.iva}%</td>
                                        {/* <td>{product.utility}%</td> */}
                                        <td>${Math.round(product.total)}</td>
                                        <td><AiTwotoneDelete className='deleteButtonListProduct' onClick={() => { deleteProduct1(index) }} /></td>
                                        <td><AiFillEdit className='iconEdit' onClick={() => { Edit(index) }} /></td>

                                    </tr>

                                )
                            })}
                        </table>
                    </div>
                    {(productOptions === null) ? (
                        <div className='containerFormulary'>
                            <div className='rightQuotes'>
                                <NavLink onClick={optionProduct} className='Textregister'><button className="button neon_Effect"><p>Producto</p></button></NavLink>
                            </div>
                            <div className='leftQuotes'>
                                <NavLink onClick={optionCompositeProduct} className='Textregister'><button className="button neon_Effect"><p>Producto compuesto</p></button></NavLink>
                            </div>
                        </div>
                    ) : (
                        (productOptions === 'product') ? (
                            <>
                                <div className='containerFormulary'>
                                    <div className="inputQuotesContainer">
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            // name="CitizenshipCard"
                                            // id="CitizenshipCard"
                                            onChange={handleProductName}
                                            className="inputquotes"
                                            placeholder=" "
                                            list="detalleList"
                                            value={productName}
                                        />
                                        <label htmlFor="name">Detalle <em className='Obligatory'>*</em></label>
                                        <datalist id="detalleList" value="clientSelect">
                                            {
                                                clientGetTable
                                                    .sort((a, b) => a.producto.localeCompare(b.producto)) // Ordenar alfabéticamente
                                                    .map((product, index) => {
                                                        return (
                                                            <option key={index}>{product.producto}</option>
                                                        )
                                                    })
                                            }
                                        </datalist>
                                    </div>

                                    <div className="inputQuotesContainer">
                                        <input
                                            type="number"
                                            autocomplete="off"
                                            onWheel={(e) => e.target.blur()}
                                            name="CitizenshipCard"
                                            id="CitizenshipCard"
                                            onChange={handleProductPrice}
                                            className="inputquotes"
                                            placeholder=" "
                                            // list="drawfemails2"
                                            value={productPrice}
                                        />
                                        <label htmlFor="name">Precio <em className='Obligatory'>*</em></label>
                                    </div>

                                    <div className="inputQuotesContainer">
                                        <input
                                            type="number"
                                            autocomplete="off"
                                            onWheel={(e) => e.target.blur()}
                                            name="CitizenshipCard"
                                            id="CitizenshipCard"
                                            onChange={handleProductQuantity}
                                            className="inputquotes"
                                            placeholder=" "
                                            // list="drawfemails2"
                                            value={productQuantity}
                                        />
                                        <label htmlFor="name">Cantidad <em className='Obligatory'>*</em></label>
                                    </div>

                                    <div className="inputQuotesContainer">
                                        <label htmlFor="name">Unidad:</label>
                                        <select name="Type" id="Type" className='inputquotes' onChange={handleUnit} value={unit}>
                                            <option value="">Unidad:</option>
                                            <option value="U">U (Unidad)</option>
                                            <option value="M">M (Metros)</option>
                                            <option value="M2">M2 (Metros Cuadrados)</option>
                                            <option value="C">C (Centimetros)</option>
                                            <option value="P">P (Pulgadas)</option>
                                            <option value="K">K (Kilogramos)</option>
                                            <option value="G">G (Gramos)</option>
                                            <option value="L">L (Libras)</option>
                                            <option value="LT">LT (Litros)</option>
                                            <option value="R">R (Radianes)</option>
                                            <option value="R">S (Segundos)</option>
                                            <option value="H">H (Horas)</option>
                                            <option value="Dia/s">Dias</option>
                                            <option value="Mes/es">Meses</option>
                                            <option value="Año/s">Años</option>
                                        </select>
                                    </div>

                                    <div className="inputQuotesContainer">
                                        <label htmlFor="name">Iva: <em className='Obligatory'>*</em></label>
                                        <select name="Type" id="Type" className='inputquotes' onChange={handleProductIva} value={productIva}>
                                            <option value="Type">Iva:</option>
                                            <option value="0">0%</option>
                                            <option value="5">5%</option>
                                            <option value="16">16%</option>
                                            <option value="19">19%</option>
                                        </select>
                                    </div>
                                    <div className="inputClientContainer">
                                        <input
                                            type="number"
                                            value={utility}
                                            name="utility"
                                            id="utility"
                                            placeholder=" "
                                            className="inputCLient"
                                            onChange={handleUtility}
                                        />
                                        <label htmlFor="utility">Utilidad (%)</label>
                                    </div>

                                </div>
                            </>
                        ) : (
                            <>
                                <div className='containerFormulary'>
                                    <div className="inputQuotesContainer">
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            // name="CitizenshipCard"
                                            // id="CitizenshipCard"
                                            onChange={handleProductName}
                                            className="inputquotes"
                                            placeholder=" "
                                            list="detalleList"
                                            value={productName}
                                        />
                                        <label htmlFor="name">Detalle <em className='Obligatory'>*</em></label>
                                        <datalist id="detalleList" value="clientSelect">
                                            {
                                                compositeProduct
                                                    .sort((a, b) => a.product.localeCompare(b.product)) // Ordenar alfabéticamente
                                                    .map((product, index) => {
                                                        return (
                                                            <option key={index}>{product.product}</option>
                                                        )
                                                    })
                                            }
                                        </datalist>
                                    </div>

                                    <div className="inputQuotesContainer">
                                        <input
                                            type="number"
                                            autocomplete="off"
                                            onWheel={(e) => e.target.blur()}
                                            name="CitizenshipCard"
                                            id="CitizenshipCard"
                                            onChange={handleProductPrice}
                                            className="inputquotes"
                                            placeholder=" "
                                            // list="drawfemails2"
                                            value={productPrice}
                                        />
                                        <label htmlFor="name">Precio <em className='Obligatory'>*</em></label>
                                    </div>

                                    <div className="inputQuotesContainer">
                                        <input
                                            type="number"
                                            autocomplete="off"
                                            onWheel={(e) => e.target.blur()}
                                            name="CitizenshipCard"
                                            id="CitizenshipCard"
                                            onChange={handleProductQuantity}
                                            className="inputquotes"
                                            placeholder=" "
                                            // list="drawfemails2"
                                            value={productQuantity}
                                        />
                                        <label htmlFor="name">Cantidad <em className='Obligatory'>*</em></label>
                                    </div>

                                    <div className="inputQuotesContainer">
                                        <label htmlFor="name">Unidad:</label>
                                        <select name="Type" id="Type" className='inputquotes' onChange={handleUnit} value={unit}>
                                            <option value="">Unidad:</option>
                                            <option value="U">U (Unidad)</option>
                                            <option value="M">M (Metros)</option>
                                            <option value="M2">M2 (Metros Cuadrados)</option>
                                            <option value="C">C (Centimetros)</option>
                                            <option value="P">P (Pulgadas)</option>
                                            <option value="K">K (Kilogramos)</option>
                                            <option value="G">G (Gramos)</option>
                                            <option value="L">L (Libras)</option>
                                            <option value="LT">LT (Litros)</option>
                                            <option value="R">R (Radianes)</option>
                                            <option value="R">S (Segundos)</option>
                                            <option value="H">H (Horas)</option>
                                            <option value="Dia/s">Dias</option>
                                            <option value="Mes/es">Meses</option>
                                            <option value="Año/s">Años</option>
                                        </select>
                                    </div>
                                    <div className="inputQuotesContainer">
                                        <label htmlFor="name">Iva: <em className='Obligatory'>*</em></label>
                                        <select name="Type" id="Type" className='inputquotes' onChange={handleProductIva} value={productIva}>
                                            <option value="Type">Iva:</option>
                                            <option value="0">0%</option>
                                            <option value="5">5%</option>
                                            <option value="16">16%</option>
                                            <option value="19">19%</option>
                                        </select>
                                    </div>
                                    <div className="inputClientContainer">
                                        <input
                                            type="number"
                                            value={utility}
                                            name="utility"
                                            id="utility"
                                            placeholder=" "
                                            className="inputCLient"
                                            onChange={handleUtility}
                                        />
                                        <label htmlFor="utility">Utilidad (%)</label>
                                    </div>
                                </div>
                                <div className='buttonContainerAddQuotes2'>
                                    <div className="buttonQuotes neon_Effect" onClick={back}><p>Atras</p></div>
                                    <div className="buttonQuotes neon_Effect" onClick={addProduct}><p>Agregar producto</p></div>
                                </div>

                            </>
                        )
                    )}
                    {productOptions === 'product' && (
                        <>
                            <h4>Materiales asociados (Opcional)</h4>

                            <div className='containerFormulary'>

                                <div className="inputQuotesContainer">
                                    <select
                                        value={currentMaterial.material?.nameofmaterial || ''}
                                        onChange={handleMaterialChange}
                                        className="inputquotes"
                                    >
                                        <option value="">Seleccione un material</option>
                                        {rawMaterialGetTable
                                            .sort((a, b) => a.nameofmaterial.localeCompare(b.nameofmaterial))
                                            .map((material, idx) => (
                                                <option key={idx} value={material.nameofmaterial}>
                                                    {material.nameofmaterial} (${material.pricePerMeasure})
                                                </option>
                                            ))
                                        }
                                    </select>
                                    <label>Material</label>
                                </div>

                                <div className="inputQuotesContainer">
                                    <input
                                        type="number"
                                        value={currentMaterial.extent}
                                        onChange={handleMaterialExtentChange}
                                        className="inputquotes"
                                        placeholder=" "
                                    />
                                    <label>{currentMaterial.material?.typeOfMeasure || "Medida"}</label>
                                </div>

                                <div className="inputQuotesContainer">
                                    <input
                                        type="text"
                                        value={currentMaterial.pricePerMeasure || ''}
                                        className="inputquotes"
                                        readOnly
                                        placeholder=" "
                                    />
                                    <label>Precio</label>
                                </div>

                                <button
                                    type="button"
                                    onClick={handleAddMaterial}
                                    className="button neon_Effect"
                                >
                                    Agregar
                                </button>

                                {selectedMaterials.length > 0 && (
                                    <div className='material-list'>
                                        <table className="minimal-table">
                                            <thead>
                                                <tr>
                                                    <th>Material</th>
                                                    <th>Medida</th>
                                                    <th>Precio Unitario</th>
                                                    <th>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedMaterials.map((material, index) => (
                                                    <tr key={index}>
                                                        <td>{material.material.nameofmaterial}</td>
                                                        <td>{material.extent || '-'}</td>
                                                        <td>${material.material.pricePerMeasure}</td>
                                                        <td>
                                                            <AiTwotoneDelete
                                                                className='deleteButtonListProduct'
                                                                onClick={() => handleRemoveMaterial(index)}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            <div className='buttonContainerAddQuotes2'>
                                <div className="buttonQuotes neon_Effect" onClick={back}><p>Atras</p></div>
                                <div className="buttonQuotes neon_Effect" onClick={addProduct}><p>Agregar producto</p></div>
                            </div>

                        </>

                    )}
                </div>
            </div >
        </form >
    )
}

export default AddProductGeneric
